import { Alert, AlertTitle, SnackbarProps } from '@mui/material';
import BaseSnackbar from './base';

export type InfoNotificationProps = SnackbarProps & {
  text?: string;
  title?: string;
  action?: React.ReactNode;
  onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
};

export default function InfoNotification({
  text,
  title,
  action,
  ...snackbarProps
}: InfoNotificationProps) {
  return (
    <BaseSnackbar {...snackbarProps}>
      <Alert
        onClose={snackbarProps.onClose}
        severity='info'
        variant='filled'
        sx={{ width: '100%' }}
        action={action}
      >
        {title && <AlertTitle color='inherit'>{title}</AlertTitle>}
        {text}
      </Alert>
    </BaseSnackbar>
  );
}
